import { logout } from '../../auth.service';
import Login from '../../../pages/Login';

const FranquiaB = () =>
{    
    localStorage.setItem("tenantId", "franquiab");
    localStorage.setItem("logoVertical", "logoSampleclient");
    logout();
    
    return Login();
};

export default FranquiaB;